var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from './action-select.style';
import { XIcon } from '@heroicons/react/solid';
import Typography from '../typography/typography';
import { classNames } from '../../utils/style-class.utils';
export var ActionSelect = function (_a) {
    var title = _a.title, actions = _a.actions, onActionSelected = _a.onActionSelected, onClose = _a.onClose;
    return (_jsxs("div", __assign({ className: "".concat(styles.wrapper) }, { children: [_jsxs("div", __assign({ className: styles.titleWrapper }, { children: [_jsx(Typography, { type: 'h3', color: 'textMid', text: title }), _jsx(XIcon, { "data-testid": 'action-select-close-icon', style: { height: '24px', width: '24px' }, onClick: onClose, color: 'grey' })] })), _jsx("div", __assign({ className: styles.actionsFlexWrapper }, { children: actions.map(function (action, index) {
                    var _a;
                    return (_jsxs("div", __assign({ "data-testid": "action-select-action-".concat(index), className: styles.actionWrapper, onClick: function () { return onActionSelected(action.value); } }, { children: [_jsx("div", __assign({ className: classNames(styles.actionCircle, (_a = "bg-".concat(action.actionColour)) !== null && _a !== void 0 ? _a : 'bg-primary') }, { children: action.icon })), _jsx(Typography, { type: 'help', className: 'py-0.5', text: action.title, color: 'textLight' })] }), "action-select-action-".concat(index)));
                }) }))] })));
};
export default ActionSelect;
//# sourceMappingURL=action-select.js.map